var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import moment from 'moment-timezone';
import { CustomAcceptWalkInClientView } from './custom-accept-walk-in-client';
import { useAvailableBarberOptions } from './use-available-barbers';
import { getSessionShop, useSession } from '../../../../infra/session';
import { useAcceptSlot } from './use-accept-slot';
import config from '../../../../../config';
export var CustomAcceptWalkInClientContainer = function (_a) {
    var onClose = _a.onClose, walkInItem = _a.walkInItem;
    var session = useSession().data;
    var shop = getSessionShop(session);
    var _b = useState(null), selectedBarberId = _b[0], setSelectedBarberId = _b[1];
    var _c = useState(moment().tz(shop.timezone).format(config.timeFormat)), selectedTime = _c[0], setSelectedTime = _c[1];
    var _d = useState(false), isSubmitting = _d[0], setIsSubmitting = _d[1];
    var barberOptions = useAvailableBarberOptions(walkInItem);
    console.log('[DEBUG] barberOptions', barberOptions);
    var acceptSlot = useAcceptSlot();
    var onAcceptUser = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, acceptSlot({
                            timezone: shop.timezone,
                            selectedBarberId: selectedBarberId,
                            selectedTime: selectedTime,
                            walkInItem: walkInItem,
                        })];
                case 2:
                    _a.sent();
                    // todo: change walk-in record status to 'accepted' here via upcoming API
                    onClose();
                    return [3 /*break*/, 4];
                case 3:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(CustomAcceptWalkInClientView, { onClose: onClose, clientName: "".concat(walkInItem.customer.firstName, " ").concat(walkInItem.customer.lastName), barberOptions: barberOptions, selectedBarberId: selectedBarberId, setSelectedBarberId: setSelectedBarberId, selectedTime: selectedTime, setSelectedTime: setSelectedTime, onAcceptUser: onAcceptUser, submitDisabled: isSubmitting, minInterval: shop.minInterval }));
};
